import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import type { Stage } from "@/types/vocational"
import { CheckCircle2, ArrowRight } from "lucide-react"
import { NavigationHeader } from "./NavigationHeader"
import { PageLayout } from "./PageLayout"

interface StageTransitionProps {
  completedStage: Stage
  nextStage: Stage
  onContinue: () => void
  onBack?: () => void
}

export function StageTransition({ completedStage, nextStage, onContinue, onBack }: StageTransitionProps) {
  return (
    <PageLayout>
      <div className="w-full max-w-lg relative">
        <NavigationHeader onBack={onBack} />
        <Card className="w-full p-8 md:p-12 shadow-[0_10px_40px_rgba(16,42,88,0.3)] text-center space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success/10 text-success mb-4">
            <CheckCircle2 className="w-8 h-8" />
          </div>

          <div className="space-y-3">
            <h2 className="text-3xl font-bold">✧ Etapa {completedStage.id} Concluída!</h2>
            <p className="text-muted-foreground">⮕ Ótimo progresso! Vamos para a próxima etapa.</p>
          </div>

          <div className="py-6 space-y-3">
            <h3 className="text-2xl font-bold text-title-blue">
              ✺ Etapa {nextStage.id}: {nextStage.title}
            </h3>
            <p className="text-[#ED7723] font-medium">{nextStage.description}</p>
          </div>

          <Button
            onClick={onContinue}
            size="lg"
            className="w-full bg-gradient-primary hover:opacity-90 transition-opacity"
          >
            Continuar <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </Card>
      </div>
    </PageLayout>
  )
}
